import {
  SITE_HEADER_HEIGHT_MOBILE_PX,
  SITE_HEADER_HEIGHT_PX,
} from '../../components/marketplace/shared/listingDetailTheme';
import { FONT_SIZES } from '../../Theme';

/**
 * Viewport height under the fixed site header (body padding-top matches HeaderOffset).
 * Using full 100vh here forces a short page scroll (header + map).
 * Breakpoint mirrors HeaderStyles (68px ≤768px, else desktop header stack).
 *
 * Layout numbers below are the React-tree source of truth for CreatorMapSimple
 * and CreatorMapRouteFallback. public/index.html LCP shell mirrors them separately.
 */
const CREATOR_MAP_VIEWPORT_SX = {
  width: '100%',
  height: `calc(100dvh - ${SITE_HEADER_HEIGHT_PX}px)`,
  maxHeight: `calc(100dvh - ${SITE_HEADER_HEIGHT_PX}px)`,
  '@media (max-width:768px)': {
    height: `calc(100dvh - ${SITE_HEADER_HEIGHT_MOBILE_PX}px)`,
    maxHeight: `calc(100dvh - ${SITE_HEADER_HEIGHT_MOBILE_PX}px)`,
  },
};

/** Left list pane beside the map (desktop split). */
export const CREATOR_MAP_LIST_PANE_SX = {
  width: '42%',
  maxWidth: 580,
  minWidth: 380,
};

/** Full-bleed map column beside the list (desktop split). */
export const CREATOR_MAP_MAP_COLUMN_INNER_SX = {
  width: '100%',
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
};

export const CREATOR_MAP_FRAME_RADIUS = '22px';

/** Map pane chrome — full remaining split, shared with RouteFallback for CLS. */
export const CREATOR_MAP_MAP_FRAME_SX = {
  flex: 1,
  minHeight: 0,
  position: 'relative',
  overflow: 'hidden',
  borderRadius: CREATOR_MAP_FRAME_RADIUS,
  border: '1px solid',
  borderColor: 'divider',
  bgcolor: 'background.soft',
};

/** Static Maps <img> cover style (Simple + RouteFallback). */
export const CREATOR_MAP_STATIC_IMG_STYLE = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
};

/** Centered gate screen over the creator-map viewport. */
export const CREATOR_MAP_GATE_SHELL_SX = {
  ...CREATOR_MAP_VIEWPORT_SX,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  p: 3,
  bgcolor: 'background.paper',
};

/** Category / Filters chip look for Creator Map sidebar rail. */
export function getCreatorMapChipSx(theme, { selected = false } = {}) {
  return {
    flexShrink: 0,
    height: 28,
    borderRadius: '999px',
    fontSize: FONT_SIZES.caption,
    fontWeight: 500,
    color: theme.palette.text.primary,
    bgcolor: theme.palette.background.paper,
    border: '1px solid',
    borderColor: selected
      ? theme.palette.text.primary
      : theme.palette.grey[300],
    '& .MuiChip-label': {
      px: 1.25,
      lineHeight: 1.2,
    },
    '& .MuiChip-icon': {
      fontSize: 15,
      ml: 0.75,
      mr: -0.5,
    },
    '&:hover': {
      bgcolor: theme.palette.background.paper,
      borderColor: selected
        ? theme.palette.text.primary
        : theme.palette.grey[400],
    },
    '&.Mui-focusVisible': {
      outline: `2px solid ${theme.palette.grey[400]}`,
      outlineOffset: 2,
    },
  };
}

export default CREATOR_MAP_VIEWPORT_SX;
